import { 
    Center,
    Flex,
} from '@chakra-ui/react'
import Order from './Order';

function Home({data}: {data: any}) {
    return(
        <Center>
            <Flex 
                mt='30px'
                flexDir='column'
                gap='15px'
            >
                {Object.entries(data).map(([key, value]) => (
                    <Order date={key} data={value}/>
                ))}
            </Flex>
        </Center>
    )
}

export default Home;